<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              :items="[
                {title: 'Xuất bản', value: true},
                {title: 'Chưa xuất bản', value: false},
              ]"
              item-text="title"
              item-value="value"
              v-model="isPublished"
              placeholder="T.thái hiển thị"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              :items="[
                {title: 'Đã hết hạn', value: true},
                {title: 'Chưa hết hạn', value: false},
              ]"
              item-text="title"
              item-value="value"
              v-model="isExpired"
              placeholder="T.thái hết hạn"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field
              v-mask="'##/##/####'"
              placeholder="Hết hạn vào ngày"
              name="login"
              v-model="deadline"
              type="text"
              color="primary"
              flat
              outlined
              dense
              validate-on-blur
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="2">
        <v-btn color="admin" height="40px" width="100%" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row class="my-0">
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-text-field v-model="title" v-if="advancedFilter" placeholder="Tiêu đề" clearable flat outlined dense />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="2" class="py-6">
        <v-btn color="admin" height="40px" width="100%" @click="advancedFilter = !advancedFilter" text>
          Nâng cao <v-icon v-if="!advancedFilter">mdi-chevron-down</v-icon><v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  data: () => ({
    advancedFilter: false,
    deadline: '',
    isPublished: null,
    isExpired: null,
    title: '',
  }),
  methods: {
    onFilterChanged() {
      let query = {
        isPublished: this.isPublished,
        isExpired: this.isExpired,
        deadline: this.deadline,
        title: this.title,
      }
      this.$emit('onFilterChanged', query)
    },
  },
}
</script>
